/** 
 * @name 全局 Mixin
 * @description 注册了所有组件公用的数据、方法和组件
 */
import { mapState } from 'vuex'
import api from '@/api'
import AdComponent from '@/components/AdComponent.vue'
import '@/css/home.scss'

export default {
	components: {
		AdComponent
	},
	computed: {
		...mapState(['deviceType', 'host', 'showDebug', 'domainConfig', 'adsensConfig', 'isAuth', 'userInfo', 'avatar', 'showCate', 'loading', 'inTop']),
		isPC() {
			return this.deviceType === 'desktop'
		},
	},
	methods: {
		/** 跳转路由 */
		go(path) {
			const { params, query } = this.$route;
			const channel = params.channel || "";
			const queryString = new URLSearchParams(query).toString();
			const fullChannel = channel ? `/${channel}` : "";
			const fullQueryString = queryString ? `?${queryString}` : "";
			this.$router.push(`${fullChannel}${path}${fullQueryString}`);
		},
		/** 跳转登录页 */
		goLogin() {
			const { params, query } = this.$route;
			const channel = params.channel || "";
			const queryString = new URLSearchParams(query).toString();
			const fullChannel = channel ? `/${channel}` : "";
			const fullQueryString = queryString ? `?${queryString}` : "";
			location.href = `${fullChannel}/login${fullQueryString}`
		},
		/** 获取用户信息 */
		async getUserInfo() {
			// 当前存在cookie，尝试获取用户信息
			if (this.$cookies.get('satoken')) {
				console.log('get user info')
				const res = await api.getUserInfo()
				if (res?.user) {
					console.log('user info get', res)
					this.$store.state.userInfo = res.user
					this.$store.state.isAuth = true
					this.$store.state.avatar = res.user.avatar
				}
			}
		},
	},
}
